module.exports = __webpack_public_path__ + "media/images/home/apple_icon-f0e82a416af10df544653150256ff0fb.png";